import  { createContext, useContext } from 'react';
import { TutorialContextType } from './types';

export const TutorialContext = createContext<TutorialContextType>({} as TutorialContextType);
export const useTutorial = () => useContext(TutorialContext);